import React from 'react';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import conf from '../../../conf';
import ExternalLink from '../../external-link';
import { mrsText } from '../constants';
const SetUpWrapper = styled.div `
  button {
    border-radius: 21px;
    font-size: 18px;
    font-weight: bold;
    height: 42px;
    line-height: 24px;
    margin-top: 20px;
    width: 155px;
  }
`;
const SetUpReturns = ({ activeFlow, accountId = null }) => {
    const { setupText1, setupText2 } = mrsText;
    const returnsUrl = accountId
        ? `${conf.CUP_URL}/cup/a/${accountId}/returns-provisioning`
        : `${conf.CUP_URL}/returns`;
    return (React.createElement(SetUpWrapper, { className: 'flex justify-content-center text-center align-items-center', role: 'main' },
        React.createElement(SRow, null,
            React.createElement(SCol, { span: '12', className: 'pad-top-lg pad-bottom-lg' },
                React.createElement("h1", { "data-ref": 'buy.returns-thankyou.setup-returns.header' },
                    "Now ",
                    "it's",
                    " time to set up Returns"),
                React.createElement("h3", { "data-ref": 'buy.returns-thankyou.setup-returns.setup-text', className: 'alt pad-top-sm' }, setupText1),
                React.createElement("h3", { "data-ref": 'buy.returns-thankyou.setup-returns.setup-subtext', className: 'alt pad-bottom-sm' }, setupText2),
                !/net-new/.test(activeFlow || '') &&
                    React.createElement(ExternalLink, { "data-ref": 'buy.returns-thankyou.setup-returns.go-to-returns.link', className: 'button primary', href: returnsUrl }, "Go to Returns")))));
};
export default SetUpReturns;
